module.exports = __webpack_public_path__ + "img/472593.2cb8598f.png";